/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb4_DescriptionInputs */

const en_visa_eb4_description = /** @type {(inputs: Visa_Eb4_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The EB-4 category covers several special immigrant classifications created by statute. Eligibility is highly category-specific, so a careful review of the client's exact circumstances is essential.`)
};

const pt_visa_eb4_description = /** @type {(inputs: Visa_Eb4_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A categoria EB-4 abrange várias classificações de imigrantes especiais criadas por lei. A elegibilidade é altamente específica da categoria, portanto, uma revisão cuidadosa das circunstâncias exatas do cliente é essencial.`)
};

const es_visa_eb4_description = /** @type {(inputs: Visa_Eb4_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La categoría EB-4 abarca varias clasificaciones de inmigrantes especiales creadas por ley. La elegibilidad es altamente específica de la categoría, por lo que una revisión cuidadosa de las circunstancias exactas del cliente es esencial.`)
};

/**
* | output |
* | --- |
* | "The EB-4 category covers several special immigrant classifications created by statute. Eligibility is highly category-specific, so a careful review of the cl..." |
*
* @param {Visa_Eb4_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb4_description = /** @type {((inputs?: Visa_Eb4_DescriptionInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb4_DescriptionInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb4_description(inputs)
	if (locale === "es") return es_visa_eb4_description(inputs)
	return en_visa_eb4_description(inputs)
});